export const FILTERS_REQUEST = 'ENROLLMENT_FILTERS_REQUEST';
export const FILTERS_REQUEST_SUCCEEDED = 'ENROLLMENT_FILTERS_REQUEST_SUCCEEDED';
export const FILTERS_REQUEST_FAILED = 'ENROLLMENT_FILTERS_REQUEST_FAILED';
export const CLEAN_FILTERS_REQUEST = 'ENROLLMENT_CLEAN_FILTERS_REQUEST';

export const GET_ENROLLMENTS_FILTERED_WITH_SERVICES = 'GET_ENROLLMENTS_FILTERED_WITH_SERVICES';
export const GET_ENROLLMENTS_FILTERED_WITH_SERVICES_SUCCEEDED = 'GET_ENROLLMENTS_FILTERED_WITH_SERVICES_SUCCEEDED';
export const GET_ENROLLMENTS_FILTERED_WITH_SERVICES_FAILED = 'GET_ENROLLMENTS_FILTERED_WITH_SERVICES_FAILED';
